// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckboxesAll_wrapper__1pqbx","wrapper_vertical":"CheckboxesAll_wrapper_vertical__Ss4m5"};